<template>
    <div>
        <q-card class="shadow-0">
            <q-card-section class="row justify-between">
                <div class="text-h6">Datos Fiscales <span class="text-subtitle2 text-grey"> </span>
                </div>
                <q-btn outline icon="save" label="Guardar" color="primary" class="q-mr-sm" @click="guardarDatos()" />
            </q-card-section>
            <q-separator />
            <q-card-section>
                <div class="row q-col-gutter-md">
                    <div class="col-12 ">
                        <q-input dense outlined v-model="form.razonSocial"
                            label="Razón Social o Nombre de la Persona" />
                    </div>

                    <div class="col-12 ">
                        <q-input dense outlined v-model="form.rfc" label="RFC" />
                    </div>

                    <div class="col-12" v-if="ValidaRegimen != ''">
                        <q-select dense class="full-width" outlined fill-input v-model="form.regimenFiscal"
                            :options="regimenFiscal" label="Régimen Fiscal" option-label="regimenFiscal" />
                    </div>

                    <div class="col-12 ">
                        <q-input dense outlined v-model="form.cp" label="Código Postal" />
                    </div>

                    <div class="col-12 ">
                        <q-input dense outlined v-model="form.emailSat" label="Correo electrónico del SAT"
                            type="email" />
                    </div>

                </div>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
import axios from 'axios'
import { QSpinnerClock } from 'quasar'

export default {
    name: 'DatosFiscales',
    data() {
        return {
            form: {
                razonSocial: '',
                rfc: '',
                regimenFiscal: {
                    regimenFiscal: ''
                },
                cp: '',
                emailSat: ''
            },
            regimenesFiscales: [
                { label: 'General de Ley Personas Morales', value: '601' },
                { label: 'Personas Físicas con Actividades Empresariales', value: '612' },
                { label: 'Régimen de Incorporación Fiscal', value: '621' },
                { label: 'Sin obligaciones fiscales', value: '625' },
                // Puedes agregar más según el catálogo del SAT
            ],
            regimenFiscalStore: [],

        }
    },
    mounted() {
        this.GetRegimenFiscal()
        this.obtenerDatos()
    },
    computed: {
        ValidaRegimen() {
            let rfc = this.form.rfc
            console.log(rfc.length)
            if (rfc.length === 12) {
                this.regimenFiscal = [];
                let filtroRegimen = this.regimenFiscalStore.filter(f => f.moral === 'Sí');
                this.regimenFiscal = [...filtroRegimen]
                console.log('m', this.regimenFiscal)
                return 'M';
            } else if (rfc.length === 13) {
                this.regimenFiscal = [];
                let filtroRegimen = this.regimenFiscalStore.filter(f => f.fisica === 'Sí');
                this.regimenFiscal = [...filtroRegimen]
                console.log('f', this.regimenFiscal)
                if (rfc === 'XAXX010101000' || rfc === 'XEXX010101000') {
                    let b = filtroRegimen.find(f => f.clave === '616');
                    this.regimenFiscal = b;
                }
                return 'F';
            }
            return "";
        },
    },
    methods: {

        async guardarDatos() {
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Guardando información. Espere...', messageColor: 'white' })
            try {
                await axios.put('Configuracion/UpdateDatosFiscales/' + this.form._id, this.form)
                this.$q.loading.hide()

                this.$q.notify({ type: 'positive', position: 'top-right', message: 'Datos guardados correctamente' })
            } catch (err) {

                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: 'Error al guardar datos' })
            }
        },

        async obtenerDatos() {
            try {
                const res = await axios.get('Configuracion/GetEmpresa')
                this.form = res.data
            } catch (err) {
                console.error(err)
                this.$q.notify({ type: 'negative', position: 'top-right', message: 'No se pudieron cargar los datos fiscales' })
            }
        }
        ,
        async GetRegimenFiscal() {
            if (this.regimenFiscalStore.length == 0) {
                try {
                    let response = await axios.get("https://api-beta-erp.contago.com.mx/api/CatalogosSat/GetCatRegimenFiscalAsync/");
                    console.log('d', response.data)
                    this.regimenFiscalStore = response.data;
                } catch (error) {
                    console.log(error);
                }
            }
        },
    }
}
</script>